import React from 'react';
import { useGuitarMatch } from '../context/GuitarMatchContext';
import { TRIAL_LIMITS } from '../services/config';

interface PremiumPaywallProps {
    children: React.ReactNode;
    featureName: string;
    description: string;
}

export const PremiumPaywall: React.FC<PremiumPaywallProps> = ({ children, featureName, description }) => {
    const { isPremium, setShowSubscriptionOffer, analysisCount } = useGuitarMatch();

    // On laisse passer si Premium OU s'il reste des essais (max free analyses complètes gratuites)
    if (isPremium || analysisCount < TRIAL_LIMITS.VISION_LOCK_COUNT) return <>{children}</>;

    return (
        <div className="relative w-full h-full min-h-[400px] group overflow-hidden rounded-[48px]">
            {/* OBFUSCATED CONTENT BACKGROUND */}
            <div className="absolute inset-0 blur-2xl grayscale opacity-30 pointer-events-none transition-all duration-1000 group-hover:blur-3xl">
                {children}
            </div>

            {/* PAYWALL INTERFACE */}
            <div className="absolute inset-0 flex flex-col items-center justify-center p-12 text-center z-50">
                <div className="w-24 h-24 rounded-full bg-smart-gold/20 border border-smart-gold/40 flex items-center justify-center mb-8 shadow-[0_0_50px_rgba(218,144,0,0.3)] animate-pulse">
                    <span className="text-4xl">💎</span>
                </div>

                <div className="space-y-4 max-w-md">
                    <h3 className="text-[10px] font-black text-smart-gold uppercase tracking-[0.6em] italic mb-2">Studio Master Exclusive</h3>
                    <h4 className="text-4xl font-black text-white italic uppercase tracking-tighter leading-none">{featureName}</h4>
                    <p className="text-slate-400 text-sm font-medium leading-relaxed italic">
                        Vos {TRIAL_LIMITS.VISION_LOCK_COUNT} analyses complètes de découverte sont terminées. Passez à l'abonnement Master pour continuer à utiliser l'IA Coach et le Vision Lab en illimité.
                    </p>
                </div>

                <div className="mt-12 flex flex-col gap-4 w-full max-w-xs">
                    <button 
                        onClick={() => setShowSubscriptionOffer(true)}
                        className="group relative flex items-center justify-center p-[2px] rounded-full overflow-hidden transition-all duration-500 hover:scale-105 shadow-2xl"
                    >
                        <div className="absolute inset-[-500%] bg-[conic-gradient(from_0deg,transparent_0deg,transparent_150deg,#DA9000_180deg,transparent_210deg,transparent_360deg)] animate-[spin_3s_linear_infinite]"></div>
                        <div className="relative px-10 py-5 bg-black rounded-full w-full">
                            <span className="text-xs font-black uppercase tracking-[0.3em] text-white">Débloquer l'IA Coach</span>
                        </div>
                    </button>
                    
                    <span className="text-[8px] font-black text-slate-600 uppercase tracking-widest">Inclus dans l'abonnement Guitar Social Club</span>
                </div>
            </div>

            {/* DECORATIVE GRID */}
            <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none"></div>
        </div>
    );
};